const HPActionItemStatuses =
{
    Open: 1,
    Invalidated: 2,
    Completed: 3,
    Initiated: 4,
    Dismissed: 5,
};

export default HPActionItemStatuses;




// WEBPACK FOOTER //
// ./src/app/config/constants/ActionItemStatusTypes.constant.js